import { SimpleCarousal } from '../../../../Atoms/Carousel';
import { CardsSecure } from '../../../../Common/SecureComponent/cards_secure';
import { Testimonial } from '../../../../Common/testimonial';
import { Heading, HeadingType } from '../../../../Typography';
import {
  PartnerNextArrow,
  PartnerPrevArrow,
} from '../../../../partner-pages/partner-carousel/utils';
import {
  pricingStats,
  testimonialSecureCards,
  testimonials,
} from '../../constants';
import { PriceStat } from './price-stat';

interface ITESTIMONIAL_PROPS {
  showSecureCards?: boolean;
}

export const TestimonialFold = ({
  showSecureCards = true,
}: ITESTIMONIAL_PROPS): JSX.Element => {
  return (
    <div className="pb-28">
      <div className={`${showSecureCards ? 'block' : 'hidden'}`}>
        <div className="flex justify-center">
          <Heading
            content={'Verified professional helping you with 100% compliance'}
            variant={HeadingType.h2}
            className="text-s-48 pt-20 text-center w-3/4 sm:text-s-32 sm:text-left sm:w-full sm:pt-10 "
          />
        </div>
        <div className="flex flex-wrap pt-7 pb-3 sm:pt-4">
          {testimonialSecureCards.map((item) => (
            <div className="w-1/3 sm:w-full" key={item.heading}>
              <CardsSecure cardData={item} />
            </div>
          ))}
        </div>
      </div>
      <Heading
        content={'Loved by over 8M+ tax payers'}
        variant={HeadingType.h2}
        className="text-s-48 pt-20 text-center sm:text-s-32 sm:pt-10 sm:text-left md:pt-16"
      />
      <div className="flex flex-wrap w-2/3 mx-auto justify-around pt-12 md:w-4/5 sm:w-full sm:pt-9">
        {pricingStats.map((item) => (
          <PriceStat stat={item.value} subtext={item.text} key={item.id} />
        ))}
      </div>
      <div className="pricing-testimonial pt-12 sm:pt-9">
        <SimpleCarousal
          slidesToShow={2}
          autoplay={true}
          infinite={true}
          slidesToScroll={1}
          arrows={true}
          dots={true}
          dotsClass="slick-dotss"
          customArrows={{
            customNextArrow: <PartnerNextArrow variant={'center'} />,
            customPrevArrow: <PartnerPrevArrow variant={'center'} />,
          }}
        >
          {testimonials.map((testimonial) => {
            return (
              <Testimonial
                key={testimonial.author}
                author={testimonial.author}
                designation={testimonial.place}
                text={testimonial.text}
              />
            );
          })}
        </SimpleCarousal>
      </div>
    </div>
  );
};
